<template>
  <app-content>
    <app-content-body>

      <div class="inner">
        <p class="buttons">
          <a
              class="btn btn_action btn_add"
              title="Vytvořit balíček"
              @click.prevent="createItem"
          >Vytvořit balíček</a>
        </p>
        <h1 v-translate>Balíčky</h1>
      </div>

      <app-table
              clickable
              deletable
              :data="items"
              :highlight-rows-on-hover="true"
              :order="params.order"
              :page-size="params.limit"
              @sort="sortItems"
              @rowClick="goToDetail"
              @deleteRow="deleteItem"
              :loading="pending"
      >
        <template slot="header">
          <app-table-header-item class="field_left">
            <app-input
                :label="translations.search"
                name="search"
                type="search"
                v-model="search"
            />
            <app-table-header-select :label="translations.provider">
                <app-select
                    :options="providerSelectOptions"
                    v-model.trim="params.idProvider"
                    @change="fetchItems(true)"
                />
            </app-table-header-select>
          </app-table-header-item>
          <app-table-header-select :label="translations.type"  class="field_right">
              <app-select
                  :options="typeOptions"
                  v-model.trim="params.type"
                  @change="fetchItems(true)"
              />
          </app-table-header-select>
        </template>

        <app-table-column first sortable attribute="name" :label="translations.name">
          <template slot-scope="row">
            <strong>
              <div v-html="row.name" />
            </strong>
          </template>
        </app-table-column>
        <app-table-column sortable attribute="providerName" :label="translations.provider">
          <template slot-scope="row">
              <div v-html="row._providerName" />
          </template>
        </app-table-column>
        <app-table-column sortable attribute="type" :label="translations.type">
          <template slot-scope="row">
              {{ enumsMap.get(row.type) }}
          </template>
        </app-table-column>
        <app-table-column sortable attribute="created" :label="translations.created">
          <template slot-scope="row">
            <div v-html="formatDate(row._created)" />
          </template>
        </app-table-column>

        <template slot="footer" v-if="itemsMetadata.totalCount > params.limit">
          <app-table-pagination
              :page="listPage"
              :itemsPerPage="params.limit"
              :totalCount="itemsMetadata.totalCount"
              @pageChanged="tablePageChanged"
          />
        </template>
      </app-table>
    </app-content-body>
  </app-content>
</template>

<script>
import getItemsListMixin from 'mixins/getItemsListMixin'
import appTitleMixin from 'mixins/appTitleMixin'
import formatDateMixin from 'mixins/formatDateMixin'
import { mapActions, mapState } from 'vuex'

const itemsListMixin = getItemsListMixin({
  apiMethodsSuffix: 'Packages',
  detailRouteName: 'vodPackage',
  enumsMap: true,
  enums: true,
})

export default {
  name: 'package-items',
  mixins: [formatDateMixin, itemsListMixin, appTitleMixin(['Balíčky'])],
  data() {
    return {
      search: ''
    }
  },
  created() {
    this.search = this.params.search

    this.getProviders({params: { order: 'name' }});
  },
  computed: {
    ...mapState({
        providers: state => state['providers']['providers'],
    }),
    typeOptions() {
      let options = [
          { name: this.translations.none, value: '' },
      ];

      this.enums.vodType.forEach((type) => {
          options.push(type);
      })

      return options;
    },
    translations() {
      return {
        search: this.$gettext('Vyhledávání'),
        provider: this.$gettext('Poskytovatel'),
        type: this.$gettext('Typ'),
        name: this.$gettext('Název'),
        active: this.$gettext('Aktivní'),
        created: this.$gettext('Založeno'),
      }
    },
    currentTitle() {
      return [
        this.$gettext('Balíčky')
      ]
    },
    providerSelectOptions() {
      return [
          { name: this.$gettext(''), value: null },
          ...this.providers.map(v => ({ name: v.name, value: v._id }))
      ]
    }
  },
  methods: {
    ...mapActions(['getProviders']),
    shouldRefreshAfterDelete() {
      return true
    }
  },
  watch: {
    search: function (newVal, oldVal) {
      if (newVal.length >= 2) {
          this.params.search = this.search
          this.fetchItems()
      } else if (newVal.length < 2 && oldVal.length >= 2) {
          this.params.search = ''
          this.fetchItems()
      }
    }
  }
}
</script>
